var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      attrs: {
        role: "region",
        id: "search",
        "aria-live": "polite",
      },
    },
    [
      _c("courseware-ribbon", {
        attrs: {
          showToolbarButton: false,
          showModeSwitchButton: false,
          buttonsClass: "single-icon",
        },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function fn() {
              return [
                _c("studip-icon", {
                  attrs: {
                    shape: "search",
                    size: "24",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "breadcrumbList",
            fn: function fn() {
              return [_c("translate", [_vm._v("Suchergebnisse")])]
            },
            proxy: true,
          },
          {
            key: "menu",
            fn: function fn() {
              return [
                _c(
                  "button",
                  {
                    attrs: {
                      title: _vm.$gettext("Suchergebnisse schließen"),
                    },
                    on: {
                      click: _vm.closeResults,
                    },
                  },
                  [
                    _c("studip-icon", {
                      attrs: {
                        shape: "decline",
                        size: "24",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: {
            id: "search-results",
          },
        },
        [
          _vm.searchResults.length > 0
            ? _c(
                "article",
                _vm._l(_vm.searchResults, function (result) {
                  return _c(
                    "section",
                    {
                      key: result["structural-element-id"],
                    },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to:
                              "/structural_element/" +
                              result["structural-element-id"],
                          },
                          nativeOn: {
                            click: function click($event) {
                              return _vm.closeResults.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: result.img !== null,
                                  expression: "result.img !== null",
                                },
                              ],
                              staticClass: "search-result-img hidden-tiny-down",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: result.img,
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "search-result-data",
                            },
                            [
                              _c("div", {
                                staticClass: "search-result-title",
                                domProps: {
                                  innerHTML: _vm._s(result.name),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "search-result-details",
                                },
                                [
                                  _c("div", {
                                    staticClass: "search-result-description",
                                    domProps: {
                                      innerHTML: _vm._s(result.description),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "search-result-information",
                            },
                            [
                              _c("div", {
                                staticClass: "search-result-time",
                                domProps: {
                                  innerHTML: _vm._s(result.date),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _c("courseware-companion-box", {
                attrs: {
                  msgCompanion: _vm.$gettext(
                    "Es wurden keine Suchergebnisse gefunden."
                  ),
                  mood: "sad",
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }